import React from 'react';
export const UnderConstructionSign = () => (
  <svg width="141px" height="98px" viewBox="0 0 141 98" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-538.000000, -1488.000000)">
        <g transform="translate(538.000000, 1488.000000)">
          <path
            d="M93.4326,94.1596 L140.1776,94.1596"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.5904,94.1596 L0.5544,94.1596"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.0386,18.7856 L68.0686,18.7856"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M65.8067,16.0629 L57.7767,16.0629 C57.7767,16.0629 56.1127,15.8969 56.1127,14.7629 C56.1127,13.6289 56.8377,13.4639 56.8377,13.4639"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M18.1983,36.8539 L26.2283,36.8539"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M83.6665,94.4965 C83.6665,96.0025 71.1185,97.2235 55.6395,97.2235 C40.1615,97.2235 27.6135,96.0025 27.6135,94.4965 C27.6135,92.9895 40.1615,91.7685 55.6395,91.7685 C71.1185,91.7685 83.6665,92.9895 83.6665,94.4965"
            fill="#D0D7DA"
          />
          <path
            d="M23.9659,34.1303 L15.9359,34.1303 C15.9359,34.1303 14.2719,33.9653 14.2719,32.8313 C14.2719,31.6973 14.9979,31.5323 14.9979,31.5323"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="45.8911 94.1928 42.7851 94.1928 34.1901 47.2328 37.6361 47.2328"
          />
          <polygon
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.8911 94.1928 42.7851 94.1928 34.1901 47.2328 37.6361 47.2328"
          />
          <g transform="translate(32.000000, 66.710000)">
            <polyline
              fill="#FFFFFF"
              points="39.0977 0.8871 40.4177 0.8871 40.4177 13.8681 0.1607 13.8681 0.1607 0.8871 1.4217 0.8871"
            />
            <polyline
              stroke="#A0A8AA"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="39.0977 0.8871 40.4177 0.8871 40.4177 13.8681 0.1607 13.8681 0.1607 0.8871 1.4217 0.8871"
            />
          </g>
          <g transform="translate(48.000000, 66.710000)">
            <path d="M0.8765,0.8871 L23.0975,0.8871" fill="#FFFFFF" />
            <path
              d="M0.8765,0.8871 L23.0975,0.8871"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(33.000000, 66.710000)">
            <path d="M0.4214,0.8871 L11.6874,0.8871" fill="#FFFFFF" />
            <path
              d="M0.4214,0.8871 L11.6874,0.8871"
              stroke="#A0A8AA"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#DDE5E8"
            points="71.103 78.109 78.807 78.109 78.807 67.597 71.103 67.597"
          />
          <polygon
            fill="#FFFFFF"
            points="34.18 62.939 76.04 62.939 76.04 49.958 34.18 49.958"
          />
          <polygon
            stroke="#A0A8AA"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="34.18 62.939 76.04 62.939 76.04 49.958 34.18 49.958"
          />
          <polygon
            fill="#ED0722"
            points="68.2119 49.5043 76.3699 63.4413 70.6579 63.4413 62.6789 49.5043"
          />
          <polygon
            fill="#ED0722"
            points="53.9331 49.5043 62.0901 63.4413 56.3791 63.4413 48.4001 49.5043"
          />
          <polygon
            fill="#ED0722"
            points="39.6538 49.5043 47.8118 63.4413 42.0998 63.4413 34.1208 49.5043"
          />
          <polygon
            fill="#FFFFFF"
            points="84.8379 94.1928 81.7329 94.1928 73.1369 47.2328 76.5829 47.2328"
          />
          <polygon
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="84.8379 94.1928 81.7329 94.1928 73.1369 47.2328 76.5829 47.2328"
          />
          <path
            d="M81.6856,64.5307 C81.6856,64.5307 82.5166,74.0677 73.7946,70.0197"
            stroke="#391572"
            strokeLinecap="round"
          />
          <g transform="translate(28.000000, 46.710000)">
            <polyline
              fill="#FFFFFF"
              points="5.5718 5.3646 6.1838 0.5226 9.6288 0.5226 3.3558 47.4826 0.2498 47.4826 4.8538 11.0486"
            />
            <polyline
              stroke="#A0A8AA"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="5.5718 5.3646 6.1838 0.5226 9.6288 0.5226 3.3558 47.4826 0.2498 47.4826 4.8538 11.0486"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="72.418 94.1928 69.312 94.1928 72.924 47.2328 76.37 47.2328"
          />
          <polygon
            stroke="#A0A8AA"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="72.418 94.1928 69.312 94.1928 72.924 47.2328 76.37 47.2328"
          />
          <polygon
            fill="#A0A8AA"
            points="72.8409 51.5404 72.8409 54.3454 75.2159 55.0244 75.4079 53.4014"
          />
          <polygon
            fill="#F3F4F6"
            points="35.3936 68.1586 33.8386 79.9766 37.6286 79.9766 44.6896 68.1586"
          />
          <polygon
            fill="#391572"
            points="85.0186 62.6381 84.3356 61.7161 78.7006 57.1061 78.3526 59.0621 81.2246 61.2361 81.2186 63.4671 83.7756 63.9711"
          />
          <g transform="translate(65.000000, 40.710000)">
            <path
              d="M7.3345,2.6693 L7.2875,2.7033 L5.2815,5.2793 L2.6515,4.1613 C2.6515,4.1613 1.4075,3.5853 0.7585,4.3533 C0.1105,5.1203 0.9745,6.2693 0.9745,6.2693 L8.2665,10.9223 L19.3375,19.8213 L21.1125,21.8533 L23.0115,20.9083 L22.6075,19.2673 C22.7995,18.7603 23.1735,18.2583 23.5685,17.7303 C23.9405,17.2323 24.3245,16.7163 24.6125,16.1303 C27.2035,10.8653 24.7675,4.3473 19.1845,1.6003 C16.8225,0.4393 13.9995,0.2073 11.3695,0.8463"
              fill="#FFD400"
            />
            <path
              d="M7.3345,2.6693 L7.2875,2.7033 L5.2815,5.2793 L2.6515,4.1613 C2.6515,4.1613 1.4075,3.5853 0.7585,4.3533 C0.1105,5.1203 0.9745,6.2693 0.9745,6.2693 L8.2665,10.9223 L19.3375,19.8213 L21.1125,21.8533 L23.0115,20.9083 L22.6075,19.2673 C22.7995,18.7603 23.1735,18.2583 23.5685,17.7303 C23.9405,17.2323 24.3245,16.7163 24.6125,16.1303 C27.2035,10.8653 24.7675,4.3473 19.1845,1.6003 C16.8225,0.4393 13.9995,0.2073 11.3695,0.8463"
              stroke="#8230DF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M73.3277,45.4731 C73.3277,45.4731 76.0267,42.6921 78.3527,42.6921 C80.6797,42.6921 82.6907,44.3101 82.6907,44.3101 L73.3277,45.4731 Z"
            fill="#FFFFFF"
          />
          <path
            d="M88.7486,53.2455 L81.6856,55.6935 C81.6856,55.6935 85.4846,57.3655 86.1646,59.0115 C88.2046,57.1055 88.7486,53.2455 88.7486,53.2455"
            fill="#EDAA14"
          />
          <g transform="translate(91.000000, 0.710000)">
            <polyline
              fill="#FFFFFF"
              points="3.0523 6.5443 0.2453 9.3523 0.2453 22.0443 9.2193 31.0193 21.9123 31.0193 30.8873 22.0443 30.8873 9.3523 21.9123 0.3763 9.2193 0.3763 6.9633 2.6333"
            />
            <polyline
              stroke="#DDE5E8"
              strokeLinecap="round"
              points="3.0523 6.5443 0.2453 9.3523 0.2453 22.0443 9.2193 31.0193 21.9123 31.0193 30.8873 22.0443 30.8873 9.3523 21.9123 0.3763 9.2193 0.3763 6.9633 2.6333"
            />
          </g>
          <path
            d="M106.5659,31.8315 L106.5659,93.1595"
            stroke="#DDE5E8"
            strokeWidth="1.5"
          />
          <polygon
            fill="#F3F4F6"
            points="111.7495 3.894 101.3825 3.894 94.0525 11.224 94.0525 21.591 101.3825 28.921 111.7495 28.921 119.0805 21.591 119.0805 11.224"
          />
          <path
            d="M100.9273,17.0629 L112.8743,17.0629"
            stroke="#FFFFFF"
            strokeWidth="5"
          />
        </g>
      </g>
    </g>
  </svg>
);
